import isNil from "lodash/isNil";
import React from "react";

import { getItem, setItem } from "@/browser";
import { Button } from "@/components/Button";
import { Flex, Img } from "@/eworkitComponents";

interface Props {}

interface State {
  showBrowserInfo: boolean;
}

export class OldBrowserInfo extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    const closeClicked = getItem("hideBrowserInfo");
    const { __OLD_BROWSER__: oldBrowser } = window;
    this.state = {
      showBrowserInfo: oldBrowser && isNil(closeClicked),
    };
  }

  handleCloseInfo = () => {
    setItem("hideBrowserInfo", true);
    this.setState({ showBrowserInfo: false });
  };

  render() {
    const supportedBrowsers = [
      {
        icon: "https://cdnjs.cloudflare.com/ajax/libs/browser-logos/45.10.0/chrome/chrome_24x24.png",
        name: "Google Chrome",
        url: "https://www.google.com/chrome/",
      },
      {
        icon: "https://cdnjs.cloudflare.com/ajax/libs/browser-logos/45.10.0/firefox/firefox_24x24.png",
        name: "Mozilla Firefox",
        url: "https://www.mozilla.org/firefox/new/",
      },
      {
        icon: "https://cdnjs.cloudflare.com/ajax/libs/browser-logos/45.10.0/safari/safari_24x24.png",
        name: "Safari",
        url: "https://support.apple.com/downloads/safari",
      },
      {
        icon: "https://cdnjs.cloudflare.com/ajax/libs/browser-logos/45.10.0/edge/edge_24x24.png",
        name: "Microsoft Edge",
        url: "https://www.microsoft.com/en-us/windows/microsoft-edge",
      },
    ];

    return (
      this.state.showBrowserInfo && (
        <Flex className="old-browser-info">
          <h6>
            For best experience upgrade to Edge or other modern browser. Currently we support the following browsers:
          </h6>
          <Flex className="old-browser-info__browsers">
            {supportedBrowsers.map((browser: any, index: number) => (
              <a href={browser.url} key={index}>
                <Img src={browser.icon} />
                {browser.name}
              </a>
            ))}
          </Flex>
          <Flex grow={1} />
          <Button icon="close" type="button" onClick={this.handleCloseInfo} />
        </Flex>
      )
    );
  }
}
